import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import classnames from 'classnames'
import { logout } from 'action/auth'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { closeMenu, setMobileView } from 'action/menu'
import SidebarMenu from 'view/component/sidebar-menu'
import SidebarToggle from 'view/component/sidebar-toggle'
import { LogoutOutlined } from '@ant-design/icons'
import placeholderLogo from 'img/PL__Logo_Data_Store_RGB_Horizontal_HR.png'
import placeholderIcon from 'img/pl-icon-purple.png'
import { Avatar } from 'antd'
import styles from './index.scss'

const getSiteLogo = (site, possibleSites, menuOpen) => {
  const selectedSite = possibleSites?.find(({ uuid }) => uuid === site.uuid)
  return menuOpen ? selectedSite?.logo : selectedSite?.icon
}

const getClassNames = (menuOpen) => (menuOpen ? styles.sidebar_wrapper_open : styles.sidebar_wrapper_close)

const getLogout = (menuOpen, logout, user) => (
  menuOpen
    ? <>
      <a
        className={styles.logout_link}
        onClick={logout}
      >
        <LogoutOutlined /> Logout
      </a>
      <Avatar
        className={classnames(styles.username)}
        shape='square'
        size='large'
      >
        {user ? `${user.first_name[0]}${user.last_name[0]}` : 'U'}
      </Avatar>
    </>
    : <>
      <a
        className={styles.logout_link_collapsed}
        onClick={logout}
      ><LogoutOutlined /> </a></>
)

const getLogoClass = (menuOpen, mobileView) => (!menuOpen && !mobileView ? styles.collapsed_logo : null)

const getToggleClass = (mobileView) => (mobileView ? styles.mobile_sidebar_toggle : styles.sidebar_toggle)

const Sidebar = ({ logout, close, menuOpen, site, possibleSites, setMobileView, mobileView, user }) => {
  window.addEventListener('resize', setMobileView)
  useEffect(setMobileView, [])
  return (
    <div className={classnames(getClassNames(menuOpen), styles.sidebar_wrapper)}>
      {site && possibleSites
      ? <>
        <img
          className={classnames(styles.dynamic_logo, getLogoClass(menuOpen, mobileView))}
          src={getSiteLogo(site, possibleSites, menuOpen)}
        />
      </>
      : <>
        <img
          className={classnames(styles.dynamic_logo_home, getLogoClass(menuOpen, mobileView))}
          src={menuOpen ? placeholderLogo : placeholderIcon}
        />
      </>
      }
      <div className={getToggleClass(mobileView)}>
        <SidebarToggle />
      </div>
      <SidebarMenu mode='inline' />
      {getLogout(menuOpen, logout, user)}
    </div>
  )
}

Sidebar.propTypes = {
  close: PropTypes.func,
  logout: PropTypes.func,
  menuOpen: PropTypes.bool,
  mobileView: PropTypes.bool,
  possibleSites: PropTypes.array,
  setMobileView: PropTypes.func,
  site: PropTypes.object,
  user: PropTypes.object
}

const mapDispacthToProps = (dispatch) => ({
  close: bindActionCreators(closeMenu, dispatch),
  logout: bindActionCreators(logout, dispatch),
  setMobileView: bindActionCreators(setMobileView, dispatch)
})

export default connect((state) => ({
  menuOpen: state.menu?.open,
  mobileView: state.menu.mobile,
  possibleSites: state.site.possibleSites,
  site: state.site.site,
  user: state.auth.user
}), mapDispacthToProps)(Sidebar)
